import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useParams, useLocation, useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import ProductCard from "./product/ProductCard";
import { useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import { Box } from "@material-ui/core";
import { SellingAreaState, DietPreference } from "./state";
import ChefRecommends from "./components/ChefRecommends";
import Bundle from "../../components/Bundle";
import FridgeConfirmationDialog from "./components/FridgeConfirmationDialog";
import HorizontalScrollContainer from "../../components/HorizontalScrollContainer";

const useStyles = makeStyles((theme: Theme) => ({
  categoryTitle: {
    padding: theme.spacing(3, 0),
  },
  container: {
    padding: theme.spacing(0, 3),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0, 2),
    },
  },
  categoriesContainer: {
    width: "100%",
  },
  sectionTitle: {
    padding: theme.spacing(2, 0, 1),
  },
  bundlesContainer: {
    display: "flex",
    overflowX: "auto",
    flexWrap: "nowrap",
    gap: `${theme.spacing(2)}px`,
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    padding: theme.spacing(1, 0),
  },
  bundleItem: {
    flex: "0 0 calc(50% - 16px)",
    [theme.breakpoints.up("sm")]: {
      flex: "0 0 calc(33% - 16px)",
    },
    [theme.breakpoints.up("md")]: {
      flex: "0 0 calc(25% - 16px)",
    },
  },
}));

function Catalog() {
  let params = useParams<{ id: string }>();
  let id = params["id"];
  const classes = useStyles();
  const catalog = useSelector((state: SellingAreaState) => state.catalog);
  const bundle = useSelector((state: SellingAreaState) => state.bundle);
  let location = useLocation();
  const history = useHistory();
  const diet: DietPreference | null = useSelector(
    (state: SellingAreaState) => state.diet,
  );

  const hasBundles = bundle && bundle.length > 0;

  return (
    <div className={classes.container}>
      {hasBundles ? (
        <>
          <Typography variant="h5" color="inherit" className={classes.sectionTitle}>
            I NOSTRI MENU
          </Typography>
          <HorizontalScrollContainer className={classes.bundlesContainer}>
            {bundle.map((b) => (
              <div key={b.id} className={classes.bundleItem}>
                <Bundle
                  id={b.id}
                  title={b.title}
                  subtitle={b.subtitle}
                  imageUrl={b.imageUrl}
                  defaultPrice={b.defaultPrice}
                  position={b.position}
                  categories={b.categories}
                />
              </div>
            ))}
          </HorizontalScrollContainer>
        </>
      ) : (
        <ChefRecommends categories={catalog?.categories} lockerId={id} />
      )}
      {catalog &&
        catalog.categories.map((category) => {
          return (
            <div className={classes.categoriesContainer} key={category.id}>
              <Typography
                variant="h5"
                color="inherit"
                className={classes.categoryTitle}
              >
                {category.label.toUpperCase()}
              </Typography>
              <Grid container spacing={2}>
                {category.items.map((item) => (
                  <ProductCard
                    showButton={true}
                    showPrice={true}
                    key={item.id}
                    item={item}
                    lockerId={id}
                    label={
                      item.price.promoLabel ? item.price.promoLabel : item.tag
                    }
                    labelColor={item.price.promoLabel ? "#E85414" : "#086d40"}
                  />
                ))}
              </Grid>
            </div>
          );
        })}
      {catalog && catalog.shopStatus === "Open" && !diet && (
        <Box marginTop={2} marginBottom={2} textAlign={"center"}>
          <Typography gutterBottom>
            Evidenzia i prodotti in base alle tue preferenze!
          </Typography>
          <Button
            onClick={() => {
              if (location.search.length > 0) {
                history.push(`${location.search}&diet_preference=show`);
              } else {
                history.push(`?diet_preference=show`);
              }
            }}
            color="primary"
            variant="outlined"
          >
            Scegli le tue preferenze
          </Button>
        </Box>
      )}
      <FridgeConfirmationDialog />
    </div>
  );
}

export default Catalog;